import React from "react"
import styled from "styled-components"
import Footer from "./Footer"
import Header from "./Header"

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  > div {
    flex: auto;
  }
`

export default ({ children }) => (
  <Wrapper>
    <Header />
    <div>{children}</div>
    <Footer />
  </Wrapper>
)
